module.exports = __webpack_public_path__ + "public/Icons/womanIcon.svg?8df0e28f";